module.exports = __webpack_public_path__ + "media/images/social/tg-6e2a24474191eff76d5da9ad7b88ebea.svg";